import { RootState } from "../../"

export const selectAlert = (state: RootState) => state.notification.alert
export const selectPopupError = (state: RootState) => state.notification.popupError
